import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { IntlProvider, Text, Localizer, withText } from 'preact-i18n';
import util from 'preact-util';

class MiniJournal extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
    }

    componentDidUpdate() {
    }

    render() {
        const { journals = [] } = this.props;
        if (!journals.length) {
            return null;
        }
        return (<div class='w-100 d-flex justify-content-center position-relative'>
            <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>
                {journals.map(journal => {
                    const fields = ['date', 'chiefComplaint', 'diagnosis', 'diagnosticTests', 'generalCondition', 'treatmentPlan'];
                    return (
                        <div className='d-flex flex-column mb-2' key={journal.id}>
                            <strong>{journal.name}</strong><br />
                            <strong>{util.formatDate(journal.date, { hour12: false, hour: '2-digit', minute: '2-digit',  locale: 'nb-NO' })}</strong><br />
                            <div class='d-flex flex-column'>
                                <div class='d-flex flex-row'>
                                    <span class='font-weight-lighter me-2'><Text id='animal.journal-chiefComplaint'>chiefComplaint</Text>:</span> {journal.chiefComplaint || 'N/A'}
                                </div>
                                <div class='d-flex flex-row'>
                                    <span class='font-weight-lighter me-2'><Text id='animal.journal-diagnosis'>Diagnosis</Text>:</span> {journal.diagnosis || 'N/A'}
                                </div>
                                <div class='d-flex flex-row'>
                                    <span class='font-weight-lighter me-2'><Text id='animal.journal-diagnosticTests'>Diagnostic Tests</Text>:</span> {journal.diagnosticTests || 'N/A'}
                                </div>
                                <div class='d-flex flex-row'>
                                    <span class='font-weight-lighter me-2'><Text id='animal.journal-generalCondition'>General Condition</Text>:</span> {journal.generalCondition || 'N/A'}
                                </div>
                                <div class='d-flex flex-row'>
                                    <span class='font-weight-lighter me-2'><Text id='animal.journal-treatmentPlan'>Treatment Plan</Text>:</span> {journal.treatmentPlan || 'N/A'}
                                </div>
                            </div>

                        </div>
                    );
                })}
            </div>
        </div>);
    }
}

export default MiniJournal;